import React, {useState} from 'react';
import {Link} from "react-router-dom";
import {useFormik} from "formik";
import {Typography} from "@material-ui/core";
import {Form, Button, InputGroup} from 'react-bootstrap';
import * as Yup from "yup";
import {BANKS} from "../../../../utils/codes";
import {checkBankAccount} from "../../../../redux/modules/auth/crud";


const validationSchema = Yup.object().shape({
  bankCd: Yup.string().required("은행을 선택해주세요"),
  accNum: Yup.string().required("계좌번로를 입력해주세요"),
  dpstStkNm:  Yup.string().required("예금주를 입력해주세요"),
});

export function Step2(props) {
  const { initValues, goBack, onSubmit } = props;
  const [isValid, setValid] = useState(false);
  const [agree1, setAgree1] = useState(false);
  const [agree2, setAgree2] = useState(false);

  const form = useFormik({
    initialValues: initValues,
    validationSchema,
    onSubmit,
  });

  const handleValidAccount = () => {
    const {accNum, bankCd, dpstStkNm} = form.values;
    checkBankAccount({accNum, bankCd, dpstStkNm})
      .then(() => setValid(true))
      .catch(err => alert(err.message));
  };

  return (
    <Form
      id="kt_login_signin_form"
      className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp mt-5"
      onSubmit={form.handleSubmit}
    >
      <div className="mb-10">
        <Typography>사업자 정보를 등록해주세요.</Typography>
        <Typography>모든 항목은 <span className="text-danger">*</span>필수 입력입니다.</Typography>
      </div>

      {/* begin: Alert */}
      {form.status && (
        <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
          <div className="alert-text font-weight-bold">{form.status}</div>
        </div>
      )}
      {/* end: Alert */}

      {/* begin: businessNo */}
      <Form.Group controlId="businessNo">
        <Form.Label>
          <span className="text-danger mr-2 align-middle">*</span>
          <span className="font-weight-boldest">정산 계좌</span>
        </Form.Label>

        <InputGroup className="mb-2" size="lg">
          <InputGroup.Prepend>
            <Form.Control
              as="select"
              variant="outline-secondary"
              size="lg"
              className="w-110px"
              style={{borderTopRightRadius: 0, borderBottomRightRadius: 0}}
              {...form.getFieldProps("bankCd")}
            >
              <option value="" disabled>은행선택</option>
              {BANKS.map(bank => (
                <option key={bank.key} value={bank.key}>{bank.label}</option>
              ))}
            </Form.Control>
          </InputGroup.Prepend>
          <Form.Control
            aria-describedby="예금주"
            className="text-center"
            placeholder="예금주"
            {...form.getFieldProps("dpstStkNm")}
          />
          <Form.Control
            aria-describedby="계좌번호"
            className="text-center"
            placeholder="계좌번호"
            {...form.getFieldProps("accNum")}
          />
        </InputGroup>
        <Button
          disabled={!form.values.bankCd || !form.values.dpstStkNm || !form.values.accNum || isValid}
          variant={isValid ? "success" : "primary"}
          className="w-100 font-weight-bolder font-size-lg"
          onClick={handleValidAccount}
        >
          {isValid ? "인증 완료" : "인증"}
        </Button>

        {form.touched.businessNo && form.errors.businessNo ? (
          <div className="fv-plugins-message-container">
            <Form.Text className="fv-help-block">{form.errors.businessNo}</Form.Text>
          </div>
        ) : (
          <Form.Text className="text-muted">
            판매대금 입금에 사용되는 계좌입니다. 정확히 입력해주세요.
          </Form.Text>
        )}
      </Form.Group>
      {/* end: businessNo */}

      {/* begin: agreement */}
      <Form.Group>
        <Form.Check
          id={`custom-${1}`}
          type="checkbox"
          className="mb-2"
          custom
          value={agree1}
          onChange={() => setAgree1(!agree1)}
          label={
            <span>
              펜타링크 <Link>이용약관</Link>에 동의 합니다.
              <span className="text-danger">(필수)</span>
            </span>
          }
        />
        <Form.Check
          id={`custom-${2}`}
          type="checkbox"
          className="mb-2"
          custom
          value={agree2}
          onChange={() => setAgree2(!agree2)}
          label={
            <span>
              펜타링크 <Link>개인정보 수집 및 이용</Link>에 동의 합니다.
              <span className="text-danger">(필수)</span>
            </span>
          }
        />
        <Form.Check
          id={`custom-${3}`}
          type="checkbox"
          className="mb-2"
          custom
          label={
            <span>
              이벤트 등 프로모션 알림 메일 수신
              <span className="text-muted">(선택)</span>
            </span>
          }
        />
      </Form.Group>
      {/* end: agreement */}

      {/* begin: Actions */}
      <div className="form-group d-flex flex-wrap flex-center">
        <div className="w-50 px-4 my-3">
          <button
            type="button"
            className="btn btn-secondary font-weight-bold px-9 py-4 w-100"
            onClick={goBack}
          >
            이전
          </button>
        </div>
        <div className="w-50 px-4 my-3">
          <button
            type="submit"
            disabled={!form.isValid || !agree1 || !agree2}
            className="btn btn-primary font-weight-bold px-9 py-4 w-100"
          >
            <span>가입 승인 신청</span>
          </button>
        </div>
      </div>
      {/* end: Actions */}
    </Form>
  )
}
